export default __webpack_public_path__ + "48178a666ba812878eb2768747c82d51.png";